import React from 'react';

const HamburgerMenuIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 8.66667V6H25V8.66667H5Z" fill="#012169"/>
<path d="M5 15.3333H25V12.6667H5V15.3333Z" fill="#012169"/>
<path d="M5 22H25V19.3333H5V22Z" fill="#012169"/>
</svg>

);

export default HamburgerMenuIcon;
